import $ from 'jquery';
import flatpickr from 'flatpickr';
import { Dutch } from 'flatpickr/dist/l10n/nl';
import Globals from '../helpers/Globals';

const { $body } = Globals;

const Timetable = {
    init() {
        if ($('.js-timetable').length) this.datepicker();
        if ($('.js-alert').length && document.cookie.indexOf('alertDisabled=') < 0) {
            $('.js-alert').removeClass('visually-hidden');
        }

        $body.on('click', '.js-close-alert', e => this.closeAlert(e));
    },

    closeAlert(e) {
        $(e.currentTarget).parents('.js-alert').hide();

        document.cookie = 'alertDisabled=true; max-age=86400; path=/;';
    },

    datepicker() {
        const url = $('.js-timetable').attr('data-url');
        const floodDatesUrl = $('.js-timetable').attr('data-floods');
        const floodDates = [];

        // Get days which contain level 3 floods
        $.ajax({
            url: floodDatesUrl,
            type: 'GET',
            dataType: 'json',
        })
            .always((data) => {
                // Parse dates and push to array
                data.forEach(date => floodDates.push(new Date(date).setHours(0, 0, 0, 0)));

                // initialize datepicker
                flatpickr('.js-datepicker', {
                    locale: Dutch,
                    altInput: true,
                    altFormat: 'j F Y',
                    dateFormat: 'Y-m-d',
                    disableMobile: true,
                    minDate: 'today',
                    defaultDate: 'today',
                    allowInput: false,
                    onDayCreate: (dObj, dStr, fp, dayElem) => {
                        // Add class if the day element contains a level 3 flood
                        if (floodDates.includes(+dayElem.dateObj)) {
                            dayElem.classList.add('flood-date');
                        }
                    },
                    onReady: (selectedDates, dateStr, instance) => {
                        if (instance.isMobile) $(instance.mobileInput).attr('step', null);
                        this.getFloodData(dateStr, url);
                    },
                    onChange: (selectedDates, dateStr) => {
                        this.getFloodData(dateStr, url);
                    },
                });
            });
    },

    getFloodData(date, url) {
        $('.js-timetable-date').remove();
        $('.js-timetable-rows').remove();

        $.ajax({
            url,
            type: 'GET',
            data: { date },
        })
            .done(data => this.buildFloodRows(data, date));
    },

    buildFloodRows(data, date) {
        const $container = $('.js-timetable-content');
        let rowTemplate = '';

        if (data.data < 1) {
            const now = new Date();
            const message = now.setFullYear(now.getFullYear() + 1) > new Date(date)
                ? 'Op basis van de beschikbare gegevens wordt er geen instroom verwacht op deze dag.'
                : 'Er is nog geen data beschikbaar voor deze datum.';
            rowTemplate = `<p class="js-timetable-rows">${message}</p>`;
            $container.append(rowTemplate);
            return;
        }

        rowTemplate = `<div class="timetable-rows js-timetable-rows">
            ${data.data.map(row => `
                <div class="timetable-row">
                    <div class="timetable-col">
                        <svg class="icon icon-clock"><use xlink:href="/svg/sprite.symbol.svg#clock" href="/svg/sprite.symbol.svg#clock"/></svg>
                        <span>${row.time} uur</span>
                    </div>
                    <div class="timetable-col">
                        <svg class="icon icon-marker"><use xlink:href="/svg/sprite.symbol.svg#marker" href="/svg/sprite.symbol.svg#marker"/></svg>
                        ${this.rowUrl(row)}
                    </div>
                    <div class="timetable-col">
                        <svg class="icon icon-inflow-${row.severity}"><use xlink:href="/svg/sprite.symbol.svg#inflow-${row.severity}" href="/svg/sprite.symbol.svg#inflow-${row.severity}"/></svg>
                    </div>
                </div>
            `).join('')}
        </div>`;

        $container.append(rowTemplate);
    },

    rowUrl(row) {
        if (!row.url) {
            return `${row.name}`;
        }

        return `<a href="${row.url}" class="timetable-url">
                    ${row.name}
                </a>`;
    },

    setInflowText(severity) {
        let inflowText = '';

        if (severity) {
            if (severity === 1) inflowText = 'Een beetje instroom';
            else if (severity === 2) inflowText = 'Normale instroom';
            else if (severity === 3) inflowText = 'Bovengemiddelde instroom';
            else inflowText = 'Instroom onbekend';
        }

        return inflowText;
    },
};

export default Timetable;
